import { snakeCase } from 'lodash';

export const getUpdateObject = (name, item, parent, grandParent, action) => {
  const common = { ...(action === 'update' && { [`${name}Id`]: item?.id }) };
  const regionCommon = { ...(action === 'create' && { areaId: grandParent?.id }) };

  switch (name) {
    case 'plannerEmail':
      return {
        ...common,
        plannerEmail: item.value
      };
    case 'division':
      return {
        ...common,
        divisionKey: snakeCase(item?.value),
        division: item?.value
      };
    case 'area':
      return {
        ...common,
        areaKey: snakeCase(item?.value),
        area: item.value
      };
    case 'district':
      return {
        areaId: parent?.id,
        ...common,
        districtKey: snakeCase(item?.value),
        district: item.value
      };
    case 'region':
      return {
        ...regionCommon,
        ...common,
        districtId: parent?.id,
        regionKey: snakeCase(item?.value),
        region: item.value
      };
    case 'meetingType':
      return {
        ...common,
        meetingTypeKey: snakeCase(item?.value),
        meetingType: item.value
      };
    case 'meetingSubType':
      return {
        meetingTypeId: parent?.id,
        ...common,
        meetingSubTypeKey: snakeCase(item?.value),
        meetingSubType: item.value,
        courseType: item.type
      };
    case 'segment':
      return {
        ...common,
        segmentKey: snakeCase(item?.value),
        segment: item.value
      };
    case 'product':
      return {
        segmentId: parent?.id,
        ...common,
        productKey: snakeCase(item?.value),
        product: item.value
      };
    case 'dentalEducationMethod':
      return {
        ...common,
        dentalEducationMethodKey: snakeCase(item?.value),
        dentalEducationMethod: item.value
      };
    case 'dentalClinicalCaseType':
      return {
        ...(action === 'update' && { dentalClinicalCaseTypeId: item?.id }),
        dentalClinicalCaseTypeKey: snakeCase(item?.value),
        dentalClinicalCaseType: item.value
      };
    default:
      return {};
  }
};

// export const getDeleteObject = (name, item, parent, grandParent) => {
export const getDeleteObject = (name, item) => {
  switch (name) {
    case 'plannerEmail':
      return { plannerEmailId: item?.id };
    case 'division':
      return { divisionId: item?.id };
    case 'area':
      return { areaId: item?.id };
    case 'district':
      // return { areaId: parent?.id, districtId: item?.id };
      return { districtId: item?.id };
    case 'region':
      // return { areaId: grandParent?.id, districtId: parent?.id, regionId: item?.id };
      return { regionId: item?.id };
    case 'meetingType':
      return { meetingTypeId: item?.id };
    case 'meetingSubType':
      return { meetingSubTypeId: item?.id };
    case 'segment':
      return { segmentId: item?.id };
    case 'product':
      // return { segmentId: parent?.id, productId: item?.id };
      return { productId: item?.id };
    case 'dentalEducationMethod':
      return { educationMethodId: item?.id };
    case 'dentalClinicalCaseType':
      return { dentalClinicalTypeProcedureId: item?.id };
    default:
      return {};
  }
};

export const getShuffleObject = (name, shuffleObject, selectedGrandParent) => {
  switch (name) {
    case 'district':
      return {
        fromAreaId: shuffleObject?.fromCategory,
        districtIds: shuffleObject?.selectedItems,
        toAreaIds: shuffleObject?.toCategory?.flatMap((item) => item?.id)
      };
    case 'region':
      return {
        areaId: selectedGrandParent?.id,
        fromDistrictId: shuffleObject?.fromCategory,
        regionIds: shuffleObject?.selectedItems,
        toDistrictIds: shuffleObject?.toCategory?.flatMap((item) => item?.id)
      };
    case 'meetingSubType':
      return {
        fromMeetingTypeId: shuffleObject?.fromCategory,
        meetingSubTypeIds: shuffleObject?.selectedItems,
        toMeetingTypeIds: shuffleObject?.toCategory?.flatMap((item) => item?.id)
      };
    case 'product':
      return {
        fromSegmentId: shuffleObject?.fromCategory,
        productIds: shuffleObject?.selectedItems,
        toSegmentIds: shuffleObject?.toCategory?.flatMap((item) => item?.id)
      };
    default:
      return {};
  }
};
